import { ComponentPropsWithoutRef, useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faCompress, faExpand } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContentContext } from 'assets/js/components/Content';
import * as Tooltip from 'components/tooltip/Tooltip';
import { twMerge } from 'tailwind-merge';

interface TableToggleFullWidthProps
    extends Omit<ComponentPropsWithoutRef<'button'>, 'children' | 'color'> {}

const TableToggleFullWidth = (props: TableToggleFullWidthProps) => {
    const { type = 'button', className = '', onClick, ...rest } = props;
    const { isFullWidth, toggleIsFullWidth } = useContext(ContentContext);

    return (
        <Tooltip.Root>
            <Tooltip.Trigger asChild={true}>
                <Button
                    variant="transparent"
                    color="neutral"
                    onClick={e => {
                        toggleIsFullWidth();
                        onClick?.(e);
                    }}
                    size="sm"
                    shape="square"
                    className={twMerge('text-gray-500 hover:bg-gray-200', className)}
                    aria-label="Table width"
                    {...rest}
                >
                    <FontAwesomeIcon
                        icon={isFullWidth ? faCompress : faExpand}
                        style={{ color: 'inherit' }}
                    />
                </Button>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse={true}>
                    <p>{isFullWidth ? 'Shrink table' : 'Expand table'}</p>
                    <Tooltip.Arrow />
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

export { TableToggleFullWidth };
export type { TableToggleFullWidthProps };
